import { useEffect, useState } from 'react';

const LOADER_DELAY = 2000;

export const useShowDelayedLoading = (isLoading: boolean, delay = LOADER_DELAY) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        let timeoutId: number;

        if (isLoading) {
            timeoutId = window.setTimeout(() => {
                setShow(true);
            }, delay);
        } else {
            setShow(false);
        }

        return () => clearTimeout(timeoutId);
    }, [isLoading, delay]);

    return show;
};
